import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import './App.css'; // Use the correct path if your CSS file is in a different folder

// Ensure that you have imported your JSON data
import peakData from './data/peaks.json';

// Set the default icon for Leaflet markers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const App = () => {
  const center = [46.0, 5.0]; // Center of the map (adjust as necessary)
  const zoom = 7; // Default zoom level

  // Preload images
  useEffect(() => {
    peakData.forEach((peak) => {
      const img = new Image();
      img.src = peak.photo; // Preload peak photos
    });
  }, []);

  return (
    <div style={{ position: 'relative', height: '100vh', width: '100%' }}>
      {/* <img
        src="/images/LogoMyPeakfinalwhite.png" // Adjust the path as necessary
        alt="Logo"
        style={{ position: 'absolute', top: '10px', left: '10px', width: '300px' }} // Adjust size and positioning
        className='logoImg'
      /> */}
      <MapContainer center={center} zoom={zoom} style={{ height: '100%', width: '100%' }}>
        <TileLayer
          url='https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}{r}.{ext}'
          minZoom={0}
          maxZoom={18}
          attribution='&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://www.stamen.com/" target="_blank">Stamen Design</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          ext='png'
        />
        {peakData.map((peak, index) => {
          // Create a custom icon using the design field
          const customIcon = new L.Icon({
            iconUrl: peak.design,
            iconSize: [50, 50], // Adjust size as needed
            iconAnchor: [25, 50], // Anchor point of the icon
            popupAnchor: [0, -50] // Point from which the popup should open relative to the iconAnchor
          });

          return (
            <Marker
              key={index}
              position={[peak.location[0], peak.location[1]]}
              icon={customIcon} // Set the custom icon here
            >
              <Popup className="peak-popup">
                <strong className="peak-name">
                  {peak.name} - {peak.altitude}m
                </strong>
                <img src={peak.photo} alt={peak.name} className="peak-photo" />
                <div className="button-div">
                <button
                    className="wear-my-peak-button"
                    onClick={() => window.parent.location.href = peak.link} // Change parent page URL
                  >
                    Voir Ma Casquette
                  </button>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default App;
